import React from "react";
import { AddCartProps } from "../../carts/views/CartView";
import ProductView from "../views/admin/ProductView";

const AdminProduct: React.FC<AddCartProps> = ({ addToCart }) => {
    return <div><ProductView addToCart={addToCart} /></div>;
};

export default AdminProduct;